import {
  campaignUpdateSchema,
  populatedCampaignSchema,
} from "@redotech/redo-marketing-common/campaigns/campaign-definition";

export const updateCampaign = {
  name: "updateCampaign" as const,
  description:
    "Update an existing campaign by id with partial fields: set the email/SMS template content, target and excluded audiences, schedule, and A/B variants. Usually called right after createCampaign to fill in everything create does not accept; use getCampaignById to see current values first.",
  mutates: true,
  input: campaignUpdateSchema,
  output: populatedCampaignSchema,
};
